export default {
  GLOBAL_MEDIA_QUERIES: {
    small: "(max-width: 599px)",
    medium: "(min-width: 600px) and (max-width: 1199px)",
    large: "(min-width: 1200px)",
    mobileS:"(max-width:320px)",
  },

  APP_ID_DEV_BASE: "ECD6169C-36C8-4917-9EB8-4829B382FAA",
  APP_ID_PROD_BASE: "ECD6169C-36C8-4917-9EB8-4829B382FAA",
}